<template>
    <ChartItem ref="chart"></ChartItem>
</template>

<script>
import ChartItem from "@/components/chart-item";


export default {
	name: "ozon-amz-statistics",
	components: {ChartItem},
	data() {
		const width = document.body.clientWidth
		let is_w = width / 1920;is_w=is_w>1?1:is_w
		return {
			el: null,
			config: {
				grid:{
					left:16/is_w+'%',
					right:'5%',
					top:'30%',
					bottom:'16%',
				},
				legend: {
					data: [
						{
							name: 'Amazon',
							color: '#e4ac3e'
						},
						{
							name: 'Ozon',
							color: '#fff'
						}
					],
					top: 20,
					textStyle: {
						fontFamily: 'Arial',
						fontSize: is_w*18,
						fill: '#fff'
					}
				},
				xAxis: {
					data: ['2025/1/31', '2025/2/1', '2025/2/2', '2025/2/3', '2025/2/4', '2025/2/5', '2025/2/6'],
					axisLabel: {
						style: {


							textBaseline: 'top',
							fill: '#cdcac3',
						}
					},
					axisLine: {
						style: {
							stroke: '#cdcac3',
							lineWidth: 1
						}
					},
					nameTextStyle: {
						fill: '#fff',
						fontSize: 12
					},
					axisTick: {
						style: {
							stroke: '#cdcac3',
							lineWidth: 1
						}
					}
				},
				yAxis: [

					{
						name: '交易额',
						data: 'value',
						min: 0,
						max: 200,
						interval: 40,
						axisLine: {
							style: {
								stroke: 'rgba(0,0,0,0)',
								lineWidth: 1,

							}
						},
						splitLine: {
							style:{
								stroke: 'rgba(255,255,255,0.3)',
							}
                        },
						axisLabel: {
							formatter: '{value} 万元',
							style: {
								fill: '#cdcac3',
								fontSize: 16
							}
						},
						nameTextStyle: {
							fill: '#fff',
							fontSize: 16
						},
						axisTick: {
							show: false
						}
					}

				],
				series: [
					{
						name: 'Amazon',
						data: [
							124.3, 112.8, 193.6, 181.4,125.0, 112.8, 95.5

						],
						type: 'line',
						lineStyle: {
							stroke: '#e8c072',
							lineWidth: 2
						},
						linePoint: {
							style: {
								stroke: '#f19745'
							}
						},
						smooth: true,
						lineArea: {
							show: true,
							gradient: ['#e4ac3e', 'rgba(247,191,80,0)']
						},
						animationCurve: 'easeOutBounce'
					},
					{
						name: 'Ozon',
						data: [
							94.3, 82.8, 73.6, 41.4,85.0, 22.8, 55.5

						],
						smooth: true,
						type: 'line',
						lineArea: {
							show: true,
							gradient: ['rgba(251, 244, 247, 1)', 'rgba(251, 214, 247, 0)']
						},
						lineStyle: {
							stroke: '#fff',
							lineWidth: 2
						},
						linePoint: {
							style: {
								stroke: '#f19745'
							}
						},

						animationCurve: 'easeOutBounce'
					},

				]
			}
		}
	},
	methods: {
		setConfig(option = {}) {
			let config = {...this.config, ...option}

			if (this.el) {
				this.el.setConfig(config)
			}else {
				this.el = this.$refs.chart
				this.el.setConfig(config)
			}
		}

	}
}
</script>

<style scoped>

</style>
